module.exports = __webpack_public_path__ + "img/158.5a2268f0.jpg";